export default "__VITE_ASSET__CIuYACjT__"